import { render, staticRenderFns } from "./RoutemapActions.vue?vue&type=template&id=635b3a4e&scoped=true&"
import script from "./RoutemapActions.vue?vue&type=script&lang=js&"
export * from "./RoutemapActions.vue?vue&type=script&lang=js&"
import style0 from "./RoutemapActions.vue?vue&type=style&index=0&id=635b3a4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635b3a4e",
  null
  
)

export default component.exports